/**
 *
 * Asynchronously loads the component for Matching
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
